<template>

    <div class="goods-specs-item">
        <div class="name" :style="{ 'width': nameWidth }">{{ name }}</div>
        <!-- 有文本时显示文本 -->
        <template v-if="text">
            <div class="content">
                <span class="text"> {{ text }} </span>
            </div>
        </template>
        <template v-else>
            <div class="content">
                <slot />
            </div>
        </template>
    </div>
</template>

<script>
import { text } from 'body-parser'


export default {
    props: {
        name: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        nameMaxLength: {
            type: Number,
            default: 0
        }
    },
    computed: {
        nameWidth() {
            const fontSize = 0.32
            const marginRight = .64
            const max = this.nameMaxLength || this.name.length
            console.log(max);
            return fontSize * max + marginRight + 'rem'
        }
    },
    data() {
        return {
        }
    },
    methods: {}
}
</script>

<style scoped lang="scss">
.goods {
    &-specs {
        &-item {
            display: flex;
            padding: 0.14rem 0;

            .name {
                width: 1.92rem;
                font-size: 0.32rem;
                color: #919499;
                line-height: 0.48rem;
            }

            .content {
                position: relative;
                display: flex;
                align-items: flex-end;
                flex: 1;
                font-size: 0;

                .text {
                    font-size: 0.32rem;
                    line-height: 0.4rem;
                    color: #22242E;
                }

            }

        }
    }
}
</style>
